"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tooltip = _interopRequireDefault(require("@react/react-spectrum/Tooltip"));

var _OverlayTrigger = _interopRequireDefault(require("@react/react-spectrum/OverlayTrigger"));

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TooltipButton = function TooltipButton(_ref) {
  var tooltip = _ref.tooltip,
      placement = _ref.placement,
      selected = _ref.selected,
      label = _ref.label,
      props = _objectWithoutProperties(_ref, ["tooltip", "placement", "selected", "label"]);

  return /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
    style: {
      pointerEvents: 'none'
    },
    placement: placement,
    selected: selected
  }, /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
    label: label
  }, props)), /*#__PURE__*/_react.default.createElement(_Tooltip.default, null, tooltip));
};

TooltipButton.defaultProps = {
  placement: 'top',
  variant: 'tool',
  selected: false,
  label: null
};
TooltipButton.propTypes = {
  tooltip: _propTypes.default.string.isRequired,
  placement: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left']),
  selected: _propTypes.default.bool,
  label: _propTypes.default.string
};
var _default = TooltipButton;
exports.default = _default;